import { useNavItems } from '../hooks';
import PortalShell from '../PortalShell';

const MainLayout = () => {
  const navItems = useNavItems();
  return <PortalShell navItems={navItems} />;
};

export default MainLayout;
